export const pasosTitle: string[] = [
  "",
  "Datos de contacto",
  "Información contable reducida",
  "",
  "Resultado",
  "",
];

export const infoPrestamoPersonalList: [string, string[]][] = [
  [" ¿Estás interesado en nuestra propuesta?", ["Completá el formulario y recibirás un e-mail de confirmación."]],
  [
    "  Un ejecutivo de cuentas se contactará con vos.",
    [
      "En los próximos días, nos comunicaremos con vos para que puedas evacuar tus dudas, coordinar un turno y especificarte la documentación requerida.",
    ],
  ],
  [
    "  Listo!",
    [
      " Con el turno que te otorgue el oficial de cuentas preséntate en la sucursal para finalizar la gestión .",
    ],
  ],
];

export const infoPaquetesBancaList: [string, string[]][] = [
  [" ¿Estás interesado en nuestra propuesta?", ["Completá el formulario y recibirás un e-mail de confirmación."]],
  [
    "  Un ejecutivo de cuentas se contactará con vos.",
    [
      "En los próximos días, nos comunicaremos con vos para que puedas evacuar tus dudas, coordinar un turno y especificarte la documentación requerida.",
    ],
  ],
  [
    "   Cuando te asignen el turno",
    [
      "  Presentate en la sucursal el día de tu turno para finalizar la gestión.",
    ],
  ],
];
export const infoAdhesionComercioCanje: [any, any[]][] = [
  ["Ingresá tu CUIT, sin guiones.",[ ],],
  ["Descargá la gráfica de la promo.",[ ],],
  ["¡Listo! Pegala en tu local o compartila en tus redes sociales.",[],],];

export const adjudicacionAnticipadaList: [string, string[]][] = [
  [" Completá los datos y en breve nos pondremos en contacto con vos para que puedas consultar tus dudas y coordinar un turno.", []],
  [
    "Una vez asignado vamos a esperarte en la sucursal, el día acordado, así podés concluir tu pedido.",
    [],
  ],
  
];
export const infoTarjetasPactar: [any, any[]][] = [
  ["Adaptá el plazo de pago de acuerdo a las necesidades del giro comercial.",[ ],],
  ["Obtené precios de contado, abonando a plazos.",[ ],],
  ["Ampliá tu cartera de proveedores.",[],],
  ["Disminuí tus costos financieros y gastos administrativos.",[],],
];

export const infoComerciosPactar: [any, any[]][] = [
  ["Riesgo cero de incobrabilidad.",[ ],],
  ["Asegurá las fechas de cobro sin afectar fondos propios.",[ ],],
  ["Ampliá tu cartera de clientes.",[],],
  ["Disminuí los gastos administrativos y de cobranzas.",[],],
];
export const lineaDeInversionList: [string, string[]][] = [
  ["Propuesta exclusiva para vos:",["Te financiamos el 100% de tu nueva camioneta o utilitario a tasa fija del 24% (*). Lo pagás en 5 años y tenés hasta 12 meses de gracia para el pago del capital." ],],
  ["Un ejecutivo comercial se contactará con vos.",["Es importante que completes de forma correcta todos los datos solicitados en este formulario para facilitar el contacto del ejecutivo comercial."],],
];

export const infoCtaPersonaJuridicaList: [string, string[]][] = [
  ["Validá tu CUIT y los datos de Apoderado / Representante legal / Firmante de la Persona Jurídica.",[ ],],
  ["Completá tus datos de contacto y tu tipo societario.",[ ],],
  ["Seleccioná tu sucursal.",[],],
  ["Adjuntá copia digitalizada del Contrato Social, Estatuto y DNI de los socios.",[],],
];

export const PUSFlList: [string, string[]][] = [
  ["¿Todavía no gestionaste tu consulta o reclamo?", ["Contactate con nosotros a través de nuestros <a style='color:#3c3c3b' href='https://www.bancoprovincia.com.ar/web/informacion_de_utilidad' >canales de atención</a>"]], 
  ["¡Estamos para ayudarte!",["Si ya realizaste tu consulta y no estás conforme con la resolución brindada, te invitamos a comunicarte con nuestros Responsables de Atención a través de este formulario.", ],],
];